/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const brush = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.226 9.447a2.37 2.37 0 0 0-2.55.444 2.408 2.408 0 0 0-.689 1.733C1.892 13.997 1 14.918 1 14.918a5.586 5.586 0 0 0 5.025-1.678 2.37 2.37 0 0 0 .472-2.48m-1.27-1.313a2.37 2.37 0 0 1 1.27 1.312m-1.27-1.312.52-.672 6.088-7.16a1.752 1.752 0 1 1 2.468 2.47l-7.092 6.067-.714.607"
    />
  </svg>
)
export default brush
